<template>
  <div class="col-xl-4 col-lg-4 col-md-4 col-sm-8 col-xs-12">
      <div class="product-item mb-60" @click="saveCurrentCatPicture" style="cursor:pointer;">
          <div style="display: block;margin-left: auto;margin-right: auto;">
            <div class="catwrapper" :style="{'background-image': getPictureBG}"></div>
          </div>
          <div class="product-description text-center">
            <div class="bottom-center-cat" style="word-wrap: break-word;">{{category.Title}}</div>
          </div>
      </div>
      <div class="mb-30"></div>
  </div>

</template>


<script>
import Vue from 'vue';

  export default {
    name: 'category-item',
    props: ['category'],
    data () {
      return {
        urlPicCat : ''
      }
    },
    created () {
       
    },
    methods: {
       saveCurrentCatPicture () {
         Vue.$currCatName = this.category.Title;
         Vue.$currCatPicUrl = this.urlPicCat;
         this.$router.push ("/category/" + this.category.CategoryID);
       },
    },
    computed: {
       getPicture () {
           if (this.category == undefined) return;
           this.urlPicCat = Vue.$urlCDN + "Images/" + this.category.PictureUrl;
           return this.urlPicCat;
       },
       getPictureBG () {
           //console.log (new Date().getTime())
           if (this.category == undefined) return '';
           this.urlPicCat = Vue.$urlCDN + "Images/" + this.category.PictureUrl;
           return "url('" + this.urlPicCat + "')";
       },
       getPictureBG2 () {
           if (this.category == undefined) return '';
           this.urlPicCat = Vue.$urlCDN + "Images/" + this.category.PictureUrl;
           return this.urlPicCat;
       }
    },
  }
</script>
<style>
  .catwrapper {
      width: 150px;
      height: 150px;
      border-radius: 25px;
      padding: 20px;
      overflow: hidden;
      background-size: cover;
      background-position: center center;
      display: block;
      margin-left: auto;
      margin-right: auto;
  }
  
  .bottom-center-cat {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 85%;
    color: #111111;
    border-radius: 10px;
    font-weight: 500;
    background-color: rgba(238, 238, 238, 0.5);
    padding:5px;
  }
</style>




// WEBPACK FOOTER //
// src/components/categories/CategoryItem.vue